import cleanedFilename from '~/util/cleanedFilename';

export default {
  OPTIONS_BUTTON: `${cleanedFilename(__filename)}-options-button`,
  DELETE_BUTTON: `${cleanedFilename(__filename)}-delete-button`,
};
